import { Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import { DropDownMUI } from "./DropDownMUI";
import { FilePicker } from "./FilePicker";
import React from "react";
import { Colors } from "../../theme/theme";

export const InputMUI = ({
  disabled,
  name,
  loading,
  value,
  onChange,
  type,
  watchingProperties,
  getValues,
  autofocus,
  error,
  ...rest
}: any) => {
  switch (type) {
    case "text":
      return (
        <TextField
          key={name}
          inputProps={{ 
            "data-testid": `text-input-${name}`,
            id: `text-input-${name}`
          }}
          label={rest?.label}
          disabled={loading || disabled}
          placeholder={rest?.placeholder}
          value={value}
          onChange={onChange}
          error={!!error}
          helperText={error}
          autoFocus={autofocus}
        />
      );
    case "email":
      return (
        <TextField
          inputProps={{
            "data-testid": `email-input-${name}`,
            id: `email-input-${name}`
          }}
          key={name}
          type="email"
          label={rest?.label}
          disabled={loading || disabled}
          placeholder={rest?.placeholder}
          value={value}
          onChange={onChange}
          error={!!error}
          helperText={error}
          autoFocus={autofocus}
        />
      );
    case "password":
      return (
        <TextField
          key={name}
          label={rest?.label}
          inputProps={{
            "data-testid": `password-input-${name}`,
            id: `password-input-${name}`
          }}
          disabled={loading || disabled}
          placeholder={rest?.placeholder}
          value={value}
          type="password"
          onChange={onChange}
          error={!!error}
          helperText={error}
          autoFocus={autofocus}
        />
      );
    case "number":
      return (
        <TextField
          type="number"
          key={name}
          inputProps={{
            "data-testid": `number-input-${name}`,
            id: `number-input-${name}`
          }}
          label={rest?.label}
          disabled={loading || disabled}
          placeholder={rest?.placeholder}
          value={value}
          onChange={onChange}
          error={!!error}
          helperText={error}
          autoFocus={autofocus}
        />
      );
    case "radio":
      return (
        <>
          <FormControl sx={{ m: 3 }} error={!!error} variant="standard">
            <FormLabel id="demo-error-radios">{rest?.label}</FormLabel>
            <RadioGroup row aria-labelledby="demo-error-radios" name="quiz" value={value} onChange={onChange}>
              {rest?.options.map((e: any, index: number) => (
                <FormControlLabel
                  key={e}
                  value={e}
                  control={
                    <Radio
                      inputProps={{ id: `demo-error-radios-${index}` }}
                    />
                  }
                  label={e}
                />
              ))}
            </RadioGroup>
            <FormHelperText>{error}</FormHelperText>
          </FormControl>
        </>
      );
    case "dropdown":
      return (
        <>
          <DropDownMUI
            dataTestId={`dropdown-${name}`}
            key={name}
            name={name}
            label={rest?.label}
            value={value}
            error={error}
            disabled={loading || disabled}
            onChange={onChange}
            watchingProperties={watchingProperties}
            getValues={getValues}
            {...rest}
          />
        </>
      );
    case "filepicker":
      return (
        <>
          <FilePicker
            dataTestId={`filepicker-${name}`}
            key={name}
            label={rest?.label}
            value={value}
            disabled={loading || disabled}
            onChange={onChange}
            name={name}
            error={error}
            {...rest}
          />
          <Typography color={Colors.error}>{error}</Typography>
        </>
      );
    case "checkbox":
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Checkbox
            id={`checkbox-${name}`}
            //@ts-ignore
            dataTestId={`checkbox-${name}`}
            key={name}
            disabled={loading || disabled}
            checked={value}
            onChanged={(value: any) => onChange(value)}
            name={name}
            label={rest?.checkboxLabel}
            styleCheckbox={{ color: Colors.primary, paddingLeft: 10 }}
          />
          <Typography color={Colors.error}>{error}</Typography>
        </div>
      );

    default:
      console.error("Not supported Type");
      throw new Error("Not supported Type");
  }
};
